import type { NextPage } from 'next';
import React, { useEffect, useState } from 'react';

import useToggle from '../../../src/hooks/useToggle';
import useDebounce from 'src/hooks/useDebounce';
import type { IAdmin } from '../../../src/models/IAdmin';
import type { IFilterSelectVariant } from '@nebo-team/vobaza.ui.filter-select/dist';

import { Title } from '@nebo-team/vobaza.ui.title/dist';
import { Preloader } from '@nebo-team/vobaza.ui.preloader/dist';
import { Button } from '@nebo-team/vobaza.ui.button/dist';
import { FilterSelect } from '@nebo-team/vobaza.ui.filter-select/dist';
import { InputSearch } from '../../../components/Inputs/InputSearch';
import { AdminsTable } from '../../../components/Admins/AdminsTable';
import { ModalEditUser } from '../../../components/Admins/ModalEditUser';

import { api } from 'shared/api';
import styles from './styles.module.scss';

const mockVariants: Array<IFilterSelectVariant> = [
  { code: 'item1', value: 'Какой-то фильтр' },
  { code: 'item2', value: 'Какой-то фильтр 1' },
  { code: 'item3', value: 'Какой-то фильтр 2' },
];

const Home: NextPage = () => {
  const [search, onChangeSearch] = useState<string>('');
  const [sort, setSort] = useState<IFilterSelectVariant>(mockVariants[0]);
  const [admins, setAdmins] = useState(null);
  const [adminAddErrors, setAdminAddErrors] = useState([]);
  const [isModalAddUser, setModalAddUser] = useToggle(false);
  const [isLoading, setLoading] = useState(true);

  const getAdminsList = async () => {
    setLoading(true);
    try {
      const response = await api.getAdminsList({
        ...(search && { 'filter[text]': search }),
      });

      setAdmins(response.data.data);
    } catch (e) {
      console.error(e);
    }

    setTimeout(() => {
      setLoading(false);
    });
  };

  const onCreateNewUser = async (values: IAdmin) => {
    try {
      await api.addAdmin(values);
      setAdminAddErrors([]);
      await getAdminsList();
      setModalAddUser();
    } catch (e: any) {
      console.error(e);
      setAdminAddErrors(e?.response?.data?.errors);
    }
  };

  //Здесь нужен API

  const debouncedSearch = useDebounce(getAdminsList, 800);
  useEffect(() => {
    if (!isLoading) debouncedSearch();
  }, [search]);

  useEffect(() => {
    getAdminsList();
  }, []);

  useEffect(() => {
    if (!isModalAddUser) {
      setAdminAddErrors([]);
    }
  }, [isModalAddUser]);

  return (
    <>
      <ModalEditUser
        onSubmitForm={onCreateNewUser}
        initialData={{}}
        active={isModalAddUser}
        onClose={setModalAddUser}
        backErrors={adminAddErrors}
        isAdd
      />

      <div className={styles.adminsContent}>
        <Title className={styles.adminsTitle} element="h1">
          Администраторы
        </Title>
        <div className={styles.adminsSearch}>
          <InputSearch value={search} onChange={onChangeSearch} placeholder={'Поиск по имени, фамилии или email'} />
        </div>

        <div className={styles.adminsControls}>
          <FilterSelect
            className={styles.merchFilter}
            variants={mockVariants}
            selected={sort}
            onChange={setSort as any}
          />

          <div className={styles.adminsAdd}>
            <Button variation={'secondary'} text="Добавить администратора" onClick={setModalAddUser} />
          </div>
        </div>

        <div className={styles.adminsTable}>{admins ? <AdminsTable adminsList={admins} /> : <Preloader />}</div>
      </div>
    </>
  );
};

export default Home;
